module.exports = __webpack_public_path__ + "img/atmark.d6941c56.svg";